import type { ReactNode } from 'react';

export interface ContainerProps {
  children: ReactNode;
  size?: 'default' | 'narrow';
  className?: string;
}

const SIZES = {
  default: 'max-w-6xl',
  narrow: 'max-w-3xl',
};

export function Container({ children, size = 'default', className = '' }: ContainerProps) {
  return <div className={`mx-auto w-full px-4 sm:px-6 lg:px-8 ${SIZES[size]} ${className}`}>{children}</div>;
}
